import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AssessmentService } from '../../../../../student360/assessment/assessment.service';
import { AssessmentField } from '../../../../../student360/assessment/assessment.model';
import { StudentService } from '../../../../../shared-components/student/student.service';
import { formatDate } from '@angular/common';
import { Student } from '../../../../../shared-components/student/student.model';
import { UserPermission } from '../../../../../shared-components/user/user-permission.model';
import { SecurityService } from '../../../../../shared-components/security/security.service';

@Component({
  selector: 'app-add-assessment-scores',
  templateUrl: './add-assessment-scores.component.html',
  styleUrls: ['./add-assessment-scores.component.css']
})
export class AddAssessmentScoresComponent implements OnInit {
  instanceId: number;
  testMasterLayoutVersionId: number;
  assessmentFields: AssessmentField[] = [];
  assessmentData: any;
  printOnTranscript = false;
  assessmentDate: Date;
  masterName = '';
  versionName = '';
  displayAssessmentFields = [];
  selectedStudent: Student;
  V9UserPermissions: UserPermission[] = [];
  userCanMarkScore: boolean;

  editMode: boolean;
  constructor(
    private assessmentService: AssessmentService,
    private studentService: StudentService,
    private dialogRef: MatDialogRef<AddAssessmentScoresComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private securityService: SecurityService,
  ) { }

  ngOnInit() {
    this.editMode = this.data.editMode;
    this.instanceId = this.data.instanceId;
    this.assessmentData = this.data.assessmentData;
    this.testMasterLayoutVersionId = this.data.testMasterLayoutVersionId;
    this.selectedStudent = this.studentService.selectedStudent;
    this.getAssessmentFields();

    this.V9UserPermissions = this.securityService.userPermissions;
    const isDelete = this.V9UserPermissions.filter(permission => permission.PermissionCode == 'AS_BUEFT');
    if ((isDelete != undefined && isDelete != null && isDelete.length > 0)) {
      this.userCanMarkScore = true;
    }
  }

  getAssessmentFields() {
    this.assessmentDate = new Date();
    this.assessmentService.getAssessmentFieldsReadByInstIdOrVersionId(this.instanceId, this.testMasterLayoutVersionId).subscribe(result => {
      this.assessmentFields = result;
      if (this.assessmentFields.length > 0) {
        this.masterName = this.assessmentFields[0].MasterName;
        this.versionName = this.assessmentFields[0].VersionName;
      }
      this.setAssessmentData();
    });
  }

  setAssessmentData() {
    this.assessmentDate = (this.assessmentData['Test Date'] != undefined) ? new Date(this.assessmentData['Test Date']) : new Date();

    this.assessmentFields.forEach(f => {
      f.FieldData = this.assessmentData[f.FieldName];
    });
    this.setAssessmentFields();
  }

  setAssessmentFields() {
    this.displayAssessmentFields = [];
    let assFields: AssessmentField[] = [];
    for (let i = 0; i < this.assessmentFields.length; i++) {
      assFields.push(this.assessmentFields[i]);

      if ((assFields.length == 3) || ((i + 1) == this.assessmentFields.length)) {
        this.displayAssessmentFields.push(assFields);
        assFields = [];
      }
    }
  }

  saveClick() {
    let instanceId = 0;
    if (this.editMode == true) {
      instanceId = this.instanceId;
    }
    const versionId = this.assessmentFields[0].VersionId;
    const isImportedData = false;
    const assDate = formatDate(this.assessmentDate, 'MM/dd/yyyy', 'en-US');
    this.assessmentFields.filter(o => o.FieldType == 1).forEach(obj => {
      if (obj.FieldData) {
        obj.FieldData = formatDate(obj.FieldData, 'MM/dd/yyyy', 'en-US');
      }
    });

    this.assessmentService.saveAssessment(this.studentService.selectedStudent.Id, instanceId, versionId, assDate, this.printOnTranscript, isImportedData, this.assessmentFields).subscribe(obj => {
      this.dialogRef.close('save');
    });
  }

  cancelClick() {
    this.dialogRef.close('cancel');
  }

}
